import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import {
    Tooltip
} from '@material-ui/core';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { useTable } from "react-table";

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import DiscountsAndInvoicesServices from '../../services/discounts-and-invoices.services';

import '../../styles/discountsAndInvoicesStyle.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';


export const DiscountsAndInvoicesDetailOriginScreen = (props) => {

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const header = location.state && location.state?.dataHeader ? location.state.dataHeader : null;

    let dateSubtract = new Date();
    dateSubtract.setMonth(dateSubtract.getMonth() - 6);

    const currencySelected = 'es-Mx';

    const [columnsDetected, setColumnsDetected] = useState([]);
    const [headerData, setHeaderData] = useState({})
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
    const [detailInvoice, setDetailInvoice ] = useState([])
    const [isDownloadFile, setIsDownloadFile] = useState(false)
    const [dataDetail, setDataDetail] = useState([]);

    const detailRef = useRef();
   
    detailRef.current = dataDetail;
    const columns = useMemo(
        () => [
            {
                Header: "",
                accessor: "total",
                isVisible: true,
                Cell: ({ value }) => <b>{value}</b>
            },
            {
                Header: "Monto Descuento Sin IVA",
                accessor: "discountAmountWithoutVAT",
                isVisible: true,

            },
            {
                Header: "Tipo de factura",
                accessor: "invoiceType",
                isVisible: true,
            },
            {
                Header: "Número de factura",
                accessor: "billNumber",
                isVisible: true,
            },
            {
                Header: "Volumen",
                accessor: "volume",
                isVisible: true
            },
            {
                Header: "Monto sin IVA",
                accessor: "amountWitoutVAT",
                isVisible: true,
            },

        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: columnsDetected,
        data: dataDetail,
    });

    useEffect(() => {
        columns[4].isVisible = header?.invoicesThatOriginatedIt !== '1' ? true : false;
        setColumnsDetected(columns.filter(column => column.isVisible));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        //console.log(header)
        setHeaderData(header);
        onSubmit(header);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /**
  * Crea el onjeto a enviar en la petición de busqueda
  * @param {string} data - información del formulario
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const onSubmit = (header) => {
        setDataDetail([]);

        setIsLoadingData(true);
        setIsErrorResponse(false);

        const params = {
            invoicesThatOriginatedIt: header.invoicesThatOriginatedIt,
            invoiceType: header.invoiceType,
            numberInvoice: header.numberInvoice
        };

        getDetailHeaderByFilters(params);

    };

    /**
  * Recupera lcabecero por filtros
  * @param {object} params - filtros para la busqueda
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const getDownload = () =>{
            console.log("this is get download", detailInvoice)
            const dataFileName = {
             broadcastDate : headerData?.broadcastDate ? headerData.broadcastDate : '---',
             discountId : headerData?.discount ? headerData.discount : '---'
            }
            const fileName = `origen_bonificaciones_${dataFileName.discountId}_${dataFileName.broadcastDate}`;
            setIsDownloadFile(true)
            DiscountsAndInvoicesServices.downloadDiscountsAndInvoicesDetailOrigin(detailInvoice).then((response)=>{
                const byteString = window.atob(response.split(',')[1]); 
                const mimeString = response.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length)
                const ia = new Uint8Array(ab)
                for(let i = 0 ; i < byteString.length; i++){
                    ia[i] = byteString.charCodeAt(i)
                }
                const dataBlob = new Blob([ab], { type:mimeString})
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
                    setIsDownloadFile(false);
                    return
                  }
              
                  const url = window.URL.createObjectURL(dataBlob);
                  const link = document.createElement('a');
                  link.href = url
                  link.setAttribute('download', `${fileName}.xls`);
                  document.body.appendChild(link);
                  link.click();
                  link.remove(); // creamos un link para descargar el doc, posteriormente se elimina el link.
                  setIsDownloadFile(false);
                },
                (error)=>{
                  setIsDownloadFile(false);
                  actionErrorConnection(error, 'Error al descargar archivo xls.');
                });
              console.log('descargar archivo xls');
    }
    
    const getDetailHeaderByFilters = (params) => {
        DiscountsAndInvoicesServices.getDiscountsAndInvoicesDetailOrigin(params)
            .then((response) => {
                console.log("this is the response", response)
                if (response.data?.discountsAndInvoicesDetailOrigenList) {
                    const recoverList = response.data.discountsAndInvoicesDetailOrigenList;
                    setDetailInvoice(response.data)
                    const resultArray = [...recoverList,
                        {
                            total:'Total',
                            discountAmountWithoutVAT: response.data?.totalDiscountAmountWithoutVAT,
                            volume: response.data?.totalVolume,
                            amountWitoutVAT: response.data?.totalAmountWitoutVAT
                        } ]
                    setDataDetail(resultArray);
                    setIsErrorResponse(false);
                } else {
                    setErrorResponse(response.message);
                    setIsErrorResponse(true);

                }
                setIsLoadingData(false);

            })
            .catch((error) => {
                setDataDetail([]);
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }

    const handleReturn = () => {
        props.history.push({
            pathname: `/operation/discounts-and-invoices/header`,
            state: { reloadFilters: true }
        });
        window.location.reload();
    }

    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu />
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Bonificaciones y Descuentos - Detalle Origen</span>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className=" d-flex justify-content-end">
                                            {
                                                isDownloadFile ?
                                                <Tooltip title="Descargargando..." placement="top-start" arrow>
                                                    <div className="custom-icon-loading me-1">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                    </div>
                                                </Tooltip>
                                                    :
                                                <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                                    <div>
                                                    <button
                                                        className="btn custom-btn-icons"
                                                        onClick={()=>getDownload()}
                                                        type="button"
                                                        disabled={isLoadingData || isErrorResponse || dataDetail.length <= 1}
                                                    >
                                                    <i className="fas fa-download"></i>
                                                    </button>
                                                    </div>
                                                </Tooltip>
                                            }
                                                <Tooltip title="Regresar" placement="top-start" arrow>
                                                    <button
                                                        className="btn custom-btn-icons"
                                                        type="button"
                                                        onClick={() => handleReturn()}
                                                    >
                                                        <i className="fas fa-chevron-left"></i>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <div className='row pt-3 pb-3'>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Tipo:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.discountType ? headerData.discountType : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Monto otorgado sin IVA:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.amountAwarded ? `$ ${parseFloat(headerData.amountAwarded).toLocaleString(currencySelected, {
                                                            minimumFractionDigits: 2
                                                        })}` : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Saldo Pendiente sin IVA:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.outstandingBalance ? `$ ${parseFloat(headerData.outstandingBalance).toLocaleString(currencySelected, {
                                                            minimumFractionDigits: 2
                                                        })}` : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className='row pt-3 pb-12'>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">ID Bonificación o descuento:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.discount ? headerData.discount : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Fecha generación descuento:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.broadcastDate ? headerData.broadcastDate : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <table
                                                className=""
                                                {...getTableProps()}
                                            >
                                                <thead>
                                                    {headerGroups.map((headerGroup, i) => (
                                                        <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                                                            {headerGroup.headers.map((column, j) => (
                                                                <th {...column.getHeaderProps()}
                                                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                                                    {column.render("Header")}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </thead>
                                                <tbody {...getTableBodyProps()}>
                                                    {rows.map((row) => {
                                                        prepareRow(row);
                                                        return (
                                                            <React.Fragment key={row.getRowProps().key}>
                                                                <tr className="element-row border-content">
                                                                    {row.cells.map((cell, i) => {
                                                                        return (
                                                                            <td className="border-element content-text padding-row-actions"
                                                                                key={i}
                                                                                {...cell.getCellProps()}>
                                                                                {/* {console.log(cell)} */}
                                                                                {
                                                                                    (cell.column.Header === 'Monto Descuento Sin IVA' || cell.column.Header === 'Monto sin IVA' || cell.column.Header === 'Volumen') ?
                                                                                    (cell.row.values?.total === 'Total' && (cell.column.Header === 'Monto Descuento Sin IVA' || cell.column.Header === 'Monto sin IVA') ?
                                                                                        <b>${`${parseFloat(cell.value).toLocaleString(currencySelected, {
                                                                                            minimumFractionDigits: 2
                                                                                        })}`}</b> :
                                                                                        <b>{`${parseFloat(cell.value).toLocaleString(currencySelected, {
                                                                                            minimumFractionDigits: 0
                                                                                        })}`}</b>
                                                                                )   :
                                                                                    cell.render("Cell")
                                                                                }
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                            {(isErrorResponse) &&
                                                <div className="error-message border-content pt-4 pb-4">
                                                    <span className="">{errorResponse && errorResponse.toString()}</span>
                                                </div>}
                                            {(isLoadingData) &&
                                                <div className=" border-content pt-4 pb-4 custom-icon-loading">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                </div>}
                                            {(dataDetail.length <= 1 && !isLoadingData && !isErrorResponse) &&
                                                <div className="element-row-message border-content pt-4 pb-4 ">
                                                    <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

DiscountsAndInvoicesDetailOriginScreen.propTypes = {
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }),
    value: PropTypes.any
};
